import { useState, useEffect, useCallback } from 'react'
import AssessmentApi from '../../API/Assessment'
import { useIntl } from 'react-intl'
import { GuideView } from './guideView'
import Loading from '../Loading/Loading'
import { developmentGuideTranslate } from '../../i18n/translatedMessages'

export function DevelopmentGuide() {
	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'

	const [loading, setLoading] = useState(false)

	const [employeeList, setEmployeeList] = useState([])
	const [employee, setEmployee] = useState({
		name: '',
		id: '',
		jobName: '',
	})

	const [showResult, setShowResult] = useState(false)

	const [page, setPage] = useState(1)
	const [filters, setFilters] = useState({
		country: '',
		area: '',
		level: '',
		text: '',
		complete: '',
	})
	const [totalPages, setTotalPages] = useState(0)
	const [textFilter, setTextFilter] = useState('')

	const getData = useCallback(async () => {
		try {
			setLoading(true)
			const companyId = JSON.parse(localStorage.getItem('user')).id
			const { area, level, country, complete, text } = filters
			const response = await AssessmentApi.getEmployeeList(companyId, page, level, area, country, complete, text)
			setEmployeeList(response.body)
			setTotalPages(Math.ceil(response.count / 50))
		} catch {
		} finally {
			setLoading(false)
		}
	}, [])

	useEffect(() => {
		getData()
	}, [])

	const handleClickResult = (name, id, jobName, email) => {
		setEmployee({ name: name, id: id, jobName: jobName })
		setShowResult(true)
	}

	const handleCloseResult = () => {
		setShowResult(false)
	}

	return (
		<>
			{showResult && <GuideView employee={employee} onCloseResult={handleCloseResult} language={language} />}
			{!showResult && (
				<div className='tw-mr-16'>
					<h3 className='tw-font-bold tw-mb-4'>{developmentGuideTranslate.developmentGuideTitle}</h3>
					<div className='tw-mb-5 tw-text-base'>{developmentGuideTranslate.developmentGuideDesc}</div>

					{loading ? (
						<Loading />
					) : (
						<>
							{employeeList?.map(item => (
								<div key={item.id}>
									<div className='tw-p-3 tw-grid tw-grid-cols-6 tw-items-center border-bottom hover:tw-bg-purple-100'>
										<div className='tw-flex tw-gap-4 tw-items-center tw-col-span-3'>
											<img
												src={item.profileImg ?? 'https://assets.mydna.company/profile-placeholder.png'}
												alt=''
												className='img-fluid rounded-circle tw-w-[64px] tw-h-[64px]'
											/>
											<div>
												<div className='tw-font-bold'>{item.name}</div>
												<div>{item.jobName}</div>
											</div>
										</div>
										<div className='tw-flex tw-justify-end tw-col-span-3'>
											{item.status ? (
												<span className='tw-text-purple-500 tw-cursor-pointer' onClick={() => handleClickResult(item.name, item.id, item.jobName)}>
													{developmentGuideTranslate.devGuideShowPlan}
												</span>
											) : (
												<span className='tw-text-gray-500'>{developmentGuideTranslate.devGuideAwaiting}</span>
											)}
										</div>
									</div>
								</div>
							))}
						</>
					)}
				</div>
			)}
		</>
	)
}
